<div class="gp-page-header">
    <div class="gp-container-normal">
        <breadcrumb></breadcrumb>
        <div class="gp-page-header-container">
            <h1 class="gp-page-header-title">{{ "SIDE_MENU.DATA.FTP_SERVER" | translate }}</h1>
            <div class="gp-page-header-actions">
                <gb-button-primary (click)="edit()" [isDisabled]="!hasSelectedItem()" translation="FTP_SERVER.BUTTON.EDIT"></gb-button-primary>
            </div>
        </div>
    </div>
</div>
<div class="gp-container-normal">
    <dx-data-grid
        class="hide-overflow w-100"
        [height]="gridHeight"
        [showBorders]="true"
        [allowColumnReordering]="true"
        [allowColumnResizing]="true"
        columnResizingMode="widget"
        [rowAlternationEnabled]="true"
        (onRowDblClick)="onRowDblClick()"
        [editing]="{ confirmDelete: false }"
        (onContentReady)="onContentReady($event)"
        [columnChooser]="columnChooserOptions"
        (onEditorPreparing)="onEditorPreparing($event)"
    >
        <dxo-column-chooser [enabled]="true"></dxo-column-chooser>
        <dxo-search-panel [visible]="true"></dxo-search-panel>
        <dxo-filter-panel [visible]="true"></dxo-filter-panel>
        <dxo-header-filter [visible]="true"></dxo-header-filter>
        <dxo-filter-row [visible]="true"></dxo-filter-row>
        <dxo-sorting mode="multiple" [showSortIndexes]="true"></dxo-sorting>
        <dxo-selection showCheckBoxesMode="never" mode="single"></dxo-selection>
        <dxo-scrolling mode="virtual" showScrollbar="always"></dxo-scrolling>
        <dxo-state-storing [enabled]="true" type="custom" [customLoad]="loadState" [customSave]="saveState" [savingTimeout]="250"></dxo-state-storing>
        <dxo-toolbar>
            <dxi-item>
                <dx-button
                    (onClick)="toggleColumnChooser()"
                    [type]="hasHiddenColumns() ? 'danger' : 'normal'"
                    icon="column-chooser"
                    [hint]="getDevExpressTranslation('dxDataGrid-columnChooserTitle')"
                ></dx-button>
            </dxi-item>
            @if (isAdmin) {
                <dxi-item>
                    <dx-button (onClick)="resetGridSettings()" type="normal" icon="revert" [hint]="'GRID.REVERT_SETTINGS' | translate"></dx-button>
                </dxi-item>
            }
        </dxo-toolbar>
        @for (column of dataGridColumns; track column) {
            <dxi-column
                [allowResizing]="true"
                [allowSorting]="true"
                [dataField]="column.dataField"
                [caption]="column.caption"
                [visible]="column.visible"
                [width]="column.width"
                [sortOrder]="column.sortOrder"
                [cellTemplate]="column.cellTemplate"
            ></dxi-column>
        }
        <div *dxTemplate="let cell of 'typeTemplate'">
            <div class="cell-overflow">{{ cell.data.type ? ("FTP_SERVER.TYPES." + cell.data.type.toUpperCase() | translate) : "" }}</div>
        </div>
    </dx-data-grid>
    <div class="mt-3 flex-start-container float-right grid-controls">
        <button class="btn btn-secondary" (click)="delete()" [disabled]="!hasSelectedItem()">
            {{ "FTP_SERVER.BUTTON.DELETE" | translate }}
        </button>
        <button class="btn btn-secondary" (click)="create()">
            {{ "FTP_SERVER.BUTTON.NEW" | translate }}
        </button>
    </div>
</div>
